<template>
  <div class="task-comment" v-loading="viewLoading">
    <div class="task-comment-wrap" ref="commentWrap">
      <div class="task-comment-item" v-for="item in commentList" :key="item.id">
        <div class="baseinfo">
          <div class="baseinfo_top">
            <Myavatar width="28px" height="28px" :userName="item.user.realname" :imgUrl="item.user.user_avatar">{{item.user.realname}}</Myavatar>
            <!-- <span class="user">{{ item.user.realname }}</span> -->
            <span class="date">{{item.create_time | formatCommentTime}}</span>
          </div>
        </div>
        <div class="comment" :id="'comment' + item.id" :ref="'comment' + item.id" :class="{'comment-rest':item.isMore}" v-html="item.comment">
        </div>
        <div v-if="item.showMore" @click="moreCheck(item)" class="more-box">{{item.isMore ? '查看更多' : '收起'}}<i class="icon iconfont iconicon_arrow_task" :class="{'putDowm':!item.isMore}"></i></div>
      </div>
    </div>
    <nothing
      v-if="!commentList || commentList.length == 0"
      :width="'125px'"
      :config="{
        type: 'img_no_news_notification',
        tip: '暂无评论'
      }"
    ></nothing>
    <!-- <div class="not-msg" v-if="!commentList || commentList.length == 0">— 暂无评论 —</div> -->
    <div class="task-comment-input" :class="{showEditor}" v-if="!isdeleted && !disabled">
      <div class="task-comment-input-wrap" v-if="!showEditor">
        <Myavatar width="28px" height="28px" :userName="userInfo.realname" :imgUrl="userInfo.user_avatar"></Myavatar>
        <el-input placeholder="点击发表评论" @focus="handleFocus"></el-input>
      </div>

      <Editor
        v-else
        :height="'212px'"
        :loading="loading"
        isComment
        :projectId="project_id"
        :confirmText="'发表评论'"
        @editorSubmit="handleEditorSubmit"
        @editorCancel="handleEditorCancel"
      ></Editor>

      <!-- <wf-button text class="button-send" @click="sendTaskComment" :loading="loading" :disabled="!comment">发送<i class="icon iconfont iconicon_send_comment"></i></wf-button> -->
    </div>
  </div>
</template>

<script>
import api from '@/services/api/task/task';
import { mapGetters } from 'vuex'
import Editor from '@/components/wangEditor'
export default {
  name: "Comment",
  components: {
    Editor
  },
  props: {
    taskId: {
      type: [Number, String],
      default: null
    },
    // 是否为已删除的任务
    isdeleted: {
      type: Boolean,
      default: false
    },
    // 项目id
    project_id: {
      type: Number,
      default: 0
    },
    // 项目冻结或者归档
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      commentList: [],
      page: 1,
      limit: 100,
      comment: "",
      isSend: false,
      loading: false,
      viewLoading: false,
      showEditor: false
    }
  },
  watch: {
    taskId() {
      if (this.taskId) {
        this.fetchTaskComment();
      }
    }
  },
  computed: {
    ...mapGetters("layout/layout", ['userInfo']),
  },
  mounted() {
    if (this.taskId) {
      this.fetchTaskComment();
    }
    this.viewImg()
  },
  methods: {
    getCommentHeight(ref, item) {
      this.$nextTick(() => {
        if (this.$refs[ref][0].offsetHeight > 83) {
          this.$set(item, 'isMore', true)
          this.$set(item, 'showMore', true)
        }
      })
    },
    fetchTaskComment() {
      this.viewLoading = true
      return api.getTaskComment({
        "per_page": this.limit,
        "page": this.page,
        "task_type": "任务",
        "task_id": this.taskId
      }).then(res => {
        this.commentList = res.data;
        this.$nextTick(() => {
          this.commentList.forEach((res, index) => {
            if (!this.isSend || index > 0) {
              this.getCommentHeight('comment' + res.id, res)
            }
          })
          this.viewLoading = false
        })
      })
    },
    sendTaskComment(val, uidArr) {
      if (!val && !this.comment) return

      // const _ts = this
      // const _node = _ts.$refs.commentWrap
      // _node.removeEventListener('click', function (e) { _ts.viewImgFn(e) })

      let str = val ? val : this.comment.replace(/%/g, '%25');
      this.loading = true
      api.postTaskComments({
        "task_id": this.taskId,
        "task_type": "任务",
        'comment': str,
        'mentioned_uid': uidArr
      }).then(async res => {
        this.isSend = true
        this.loading = false

        this.showEditor = false
        // this.viewImg()

        this.postScorllTop()
        await this.fetchTaskComment();
        this.comment = "";
      })
    },
    moreCheck(item) {
      console.log(item)
      this.$set(item, 'isMore', !item.isMore)
    },
    postScorllTop() {
      this.$emit('toScorllTop')
    },
    handleFocus() {
      this.showEditor = true
    },
    handleEditorSubmit(con, val, text, uidArr) {
      // console.log('val:' + val, 'text:' + text, uidArr, 1111)
      // const _text = val.replace(/<\/?p[^>]*>/gi, '').replaceAll('<br/>', '')
      const _text = text.replace(/\s+/g, "").replace(/&nbsp+/g, "")
      if ((val.indexOf('<img') < 0 && !_text) && !uidArr) {
        this.$message.warning('请输入内容')
        return
      }
      // console.log(con, val, uidArr)
      this.sendTaskComment(val, uidArr)
    },
    handleEditorCancel() {
      this.showEditor = false
    },
    viewImg() {
      const _ts = this
      const _node = _ts.$refs.commentWrap
      _node.addEventListener('click', (e) => _ts.viewImgFn(e))
    },
    viewImgFn(e) {
      const _ts = this
      const target = e.target
      if (target.nodeName === 'IMG') {
        const _url = target.currentSrc
        // console.log(_url)
        _ts.$viewerApi({ images: [_url] })
      }

    }
  }
}
</script>

<style lang="scss">
.task-comment-item {
  .comment {
    img {
      width: 100%;
    }
    ul,
    ol {
      padding-left: 16px;
    }
    ul li {
      list-style: disc;
    }
    ol li {
      list-style: decimal;
    }
  }
  p {
    text-align: initial;
  }
}
.task-comment-input {
  .task-comment-input-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    .avatar-box {
      margin-left: 24px;
    }
    .el-input {
      flex: 1;
      margin-left: 8px;
      .el-input__inner {
        padding: 0 8px;
        height: 54px;
        border: none !important;
      }
    }
  }

  &.showEditor {
    padding: 0 24px 16px 0;
    .editor-con {
      border: none !important;
      div:first-child {
        border-bottom: none !important;
      }
      .w-e-bar {
        padding: 0 !important;
      }
    }
    .wrap-bottom {
      border-top: none;
      padding: 16px 0 0;
      height: 32px;
    }
  }
}
</style>
